import './Stats.css';

function Stats() {
    return (
        <div className='stats'>
            <div className='stats__texts'>
                <h3 className='stats__title'>11&nbsp;Years of&nbsp;Global Luxury&nbsp;Expertise</h3>
                <p className='stats__text'>What began as&nbsp;a&nbsp;passion for horology has grown into a&nbsp;trusted name for luxury collectors worldwide</p>
            </div>
            <div className='stats__cards'>
                <div className='stats__card'>
                    <p className='stats__card-number'>3,145</p>
                    <h4 className='stats__card-title'>Watches sold</h4>
                </div>
                <div className='stats__card'>
                    <p className='stats__card-number'>671</p>
                    <h4 className='stats__card-title'>Authentic timepieces</h4>
                </div>
                <div className='stats__card'>
                    <p className='stats__card-number'>1,500+</p>
                    <h4 className='stats__card-title'>Clients</h4>
                </div>
                <div className='stats__card'>
                    <p className='stats__card-number'>193</p>
                    <h4 className='stats__card-title'>Countries</h4>
                </div>
            </div>
        </div>
    );
}

export default Stats